import { createErrorHandler } from "@mgdx-libs/error-handler/lib/createErrorHandler";
import { isSentryEnabled } from "@mgdx-libs/error-handler/utils/sentry";
import { logger } from "@mgdx-libs/logger";
import * as Sentry from "@sentry/react";
import { signOut } from "firebase/auth";
import { useCallback } from "react";

import { getFirebaseAuth } from "../utils/getFirebaseAuth";

export type SignOutFirebase = () => void | Promise<void>;
const errorHandlerReport = createErrorHandler();

export const useSignOutFirebase = () =>
  useCallback<SignOutFirebase>(async () => {
    const firebaseAuth = getFirebaseAuth();
    if (firebaseAuth) {
      await signOut(firebaseAuth)
        .then(() => {
          logger.debug("Sign out Firebase");
          if (isSentryEnabled()) {
            const scope = Sentry.getCurrentScope();
            scope.setUser(null);
          }
        })
        .catch(async (error) => {
          logger.error(error);
          await errorHandlerReport(error);
        });
    }
  }, []);
